import { all, call, put, takeEvery } from 'redux-saga/effects';
import isEmpty from 'lodash/isEmpty';
import { EVENT_TYPES } from '../utils/constants';
import * as types from '../actions/types';
import { updateManagedSoundcast } from '../actions';
import { createDynamicLiveChannel } from '../helpers/channels';

const soundcastHandler = function*(snapshot, soundcastId) {
  try {
    // const newSoundcast = snapshot.val() || { id: soundcastId };
    const newSoundcast = snapshot.val();
    // console.log('Soundcast from live channel', soundcastId, newSoundcast);
    if (!isEmpty(newSoundcast)) {
      yield put(
        updateManagedSoundcast({
          [soundcastId]: {
            soundcastId,
            ...newSoundcast,
          },
        })
      );
    }
  } catch (err) {
    console.log(`Soundcast error`, err.message);
  }
};

const soundcastLiveChannelWorker = function*({ payload: soundcastId }) {
  yield call(createDynamicLiveChannel, {
    closeChannelAction: types.CLOSE_SOUNDCAST_CHANNEL,
    eventType: EVENT_TYPES.VALUE,
    handler: soundcastHandler,
    pathToListen: `soundcasts/${soundcastId}`,
    entity: soundcastId,
    skipFirstRound: false,
  });
};

const soundcastLiveChannelWatcher = function*() {
  yield takeEvery(types.OPEN_SOUNDCAST_CHANNEL, soundcastLiveChannelWorker);
};

export default function*() {
  yield all([call(soundcastLiveChannelWatcher)]);
}
